import { render, staticRenderFns } from "./NewInfoNew.vue?vue&type=template&id=61183440&scoped=true&"
import script from "./NewInfoNew.vue?vue&type=script&lang=js&"
export * from "./NewInfoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61183440",
  null
  
)

export default component.exports